export default "__VITE_ASSET__7ceBUqA2__"